// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollCalendarUpdatePartnerResponseDto
 */
export interface IPayrollCalendarUpdatePartnerResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    frequency_type?: IPayrollCalendarUpdatePartnerResponseDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    status?: IPayrollCalendarUpdatePartnerResponseDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    next_autoprolong_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    json_config?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    group_type?: IPayrollCalendarUpdatePartnerResponseDtoGroupTypeEnum;
    /**
     * 
     * @type {Set<Date>}
     * @memberof IPayrollCalendarUpdatePartnerResponseDto
     */
    scheduled_dates?: Set<Date>;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarUpdatePartnerResponseDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarUpdatePartnerResponseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarUpdatePartnerResponseDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarUpdatePartnerResponseDto interface.
 */
export function instanceOfIPayrollCalendarUpdatePartnerResponseDto(value: object): value is IPayrollCalendarUpdatePartnerResponseDto {
    return true;
}

export function IPayrollCalendarUpdatePartnerResponseDtoFromJSON(json: any): IPayrollCalendarUpdatePartnerResponseDto {
    return IPayrollCalendarUpdatePartnerResponseDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarUpdatePartnerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarUpdatePartnerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'next_autoprolong_at': json['next_autoprolong_at'] == null ? undefined : (new Date(json['next_autoprolong_at'])),
        'json_config': json['json_config'] == null ? undefined : json['json_config'],
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
        'scheduled_dates': json['scheduled_dates'] == null ? undefined : new Set(json['scheduled_dates']),
    };
}

export function IPayrollCalendarUpdatePartnerResponseDtoToJSON(json: any): IPayrollCalendarUpdatePartnerResponseDto {
    return IPayrollCalendarUpdatePartnerResponseDtoToJSONTyped(json, false);
}

export function IPayrollCalendarUpdatePartnerResponseDtoToJSONTyped(value?: IPayrollCalendarUpdatePartnerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'frequency_type': value['frequency_type'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString()),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString()),
        'status': value['status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'next_autoprolong_at': value['next_autoprolong_at'] == null ? undefined : ((value['next_autoprolong_at']).toISOString()),
        'json_config': value['json_config'],
        'group_type': value['group_type'],
        'scheduled_dates': value['scheduled_dates'] == null ? undefined : Array.from(value['scheduled_dates'] as Set<any>),
    };
}

